import { render, staticRenderFns } from "./notify.vue?vue&type=template&id=c7fdeb5a&scoped=true"
import script from "./notify.vue?vue&type=script&lang=js"
export * from "./notify.vue?vue&type=script&lang=js"
import style0 from "./notify.vue?vue&type=style&index=0&id=c7fdeb5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fdeb5a",
  null
  
)

export default component.exports